var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamaskBrowserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.5 423.2",
    style: {
      enableBackground: "new 0 0 488.5 423.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{fill:#F6851B;}\n\t.st2{fill:#E2761B;stroke:#E2761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#E4761B;stroke:#E4761B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D7C1B3;stroke:#D7C1B3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#233447;stroke:#233447;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#CD6116;stroke:#CD6116;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:#E4751F;stroke:#E4751F;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:#F6851B;stroke:#F6851B;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:#C0AD9E;stroke:#C0AD9E;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:#161616;stroke:#161616;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#763D16;stroke:#763D16;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.5,0c-61.6,0-123.2,0-184.8,0l0,0C182.6,0,120.5,0,58.4,0C25.2,0,0.1,24.7,0.1,57.7 C0,160.2,0,262.7,0.2,365.2c0,5.9,0.8,11.9,2.5,17.5c7.2,24.1,28.7,40.2,54,40.4c27.5,0.2,55,0.1,82.5,0.1 c96.6,0,193.1,0,289.7,0c9.5,0,18.7-1.3,27.1-5.6c21.5-11,32.4-28.8,32.4-52.9c0.1-101.8,0-203.6,0.1-305.4 C488.4,24.9,463.8,0.1,429.5,0z M423.5,17.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8 S413.2,17.5,423.5,17.5z M358.7,17.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8S348.3,17.5,358.7,17.5z  M293.9,17.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8S283.5,17.5,293.9,17.5z M456.2,75 c0,87.2,0,202.4,0,289.6c0,16.1-10.3,26.4-26.4,26.4c-123.7,0-247.3,0-371,0c-16.6,0-26.6-10-26.6-26.6c0-87.4,0-202.7,0-290.1 c0-1.5,0.1-3,0.2-4.8c141.4,0,282.2,0,423.8,0C456.2,71.4,456.2,73.2,456.2,75z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1716,0c-61.6,0-123.2,0-184.8,0l0,0c-62.1,0-124.2,0-186.3,0c-33.2,0-58.3,24.7-58.3,57.7 c-0.1,102.5-0.1,205,0.1,307.5c0,5.9,0.8,11.9,2.5,17.5c7.2,24.1,28.7,40.2,54,40.4c27.5,0.2,55,0.1,82.5,0.1 c96.6,0,193.1,0,289.7,0c9.5,0,18.7-1.3,27.1-5.6c21.5-11,32.4-28.8,32.4-52.9c0.1-101.8,0-203.6,0.1-305.4 C1774.9,24.9,1750.3,0.1,1716,0z M1710,29.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8 S1699.7,29.5,1710,29.5z M1645.2,29.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8c-10.4,0-18.8-8.4-18.8-18.8 S1634.8,29.5,1645.2,29.5z M1580.4,29.5c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8s-18.8-8.4-18.8-18.8 S1570,29.5,1580.4,29.5z M1742.7,103c0,87.2,0,174.4,0,261.6c0,16.1-10.3,26.4-26.4,26.4c-123.7,0-247.3,0-371,0 c-16.6,0-26.6-10-26.6-26.6c0-87.4,0-174.7,0-262.1c0-1.5,0.1-3,0.2-4.8c141.4,0,282.2,0,423.8,0 C1742.7,99.4,1742.7,101.2,1742.7,103z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "353.1,126.5 261.2,194.7 278.2,154.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "141,126.5 232.1,195.4 216,154.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "320.1,284.7 295.6,322.2 348,336.6 363,285.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "131.3,285.5 146.2,336.6 198.6,322.2 174.1,284.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "195.7,221.3 181.1,243.4 233.1,245.7 231.2,189.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "298.5,221.3 262.4,189.2 261.2,245.7 313.1,243.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "198.6,322.2 229.8,306.9 202.9,285.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "264.3,306.9 295.6,322.2 291.2,285.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "295.6,322.2 264.3,306.9 266.8,327.4 266.5,336  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.6,322.2 227.7,336 227.5,327.4 229.8,306.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "228.2,272.4 202.1,264.7 220.5,256.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "265.9,272.4 273.6,256.3 292.1,264.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "198.6,322.2 203,284.7 174.1,285.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "291.2,284.7 295.6,322.2 320.1,285.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "313.1,243.4 261.2,245.7 266,272.4 273.7,256.3 292.2,264.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "202.1,264.7 220.6,256.3 228.2,272.4 233.1,245.7 181.1,243.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "181.1,243.4 202.9,285.9 202.1,264.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "292.2,264.7 291.2,285.9 313.1,243.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "233.1,245.7 228.2,272.4 234.3,303.9 235.6,262.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "261.2,245.7 258.7,262.3 259.8,303.9 266,272.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "266,272.4 259.8,303.9 264.3,306.9 291.2,285.9 292.2,264.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "202.1,264.7 202.9,285.9 229.8,306.9 234.3,303.9 228.2,272.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "266.5,336 266.8,327.4 264.5,325.3 229.6,325.3 227.5,327.4 227.7,336 198.6,322.2 208.8,330.5  229.4,344.8 264.7,344.8 285.4,330.5 295.6,322.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "264.3,306.9 259.8,303.9 234.3,303.9 229.8,306.9 227.5,327.4 229.6,325.3 264.5,325.3 266.8,327.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "357,199.2 364.9,161.5 353.1,126.5 264.3,192.4 298.5,221.3 346.8,235.5 357.5,223 352.9,219.7  360.2,212.9 354.5,208.5 361.9,202.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "129.3,161.5 137.2,199.2 132.2,202.9 139.6,208.5 134,212.9 141.3,219.7 136.7,223 147.4,235.5  195.7,221.3 229.8,192.4 141,126.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "346.8,235.5 298.5,221.3 313.1,243.4 291.2,285.9 320.1,285.5 363,285.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "195.7,221.3 147.4,235.5 131.3,285.5 174.1,285.5 202.9,285.9 181.1,243.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "261.2,245.7 264.3,192.4 278.3,154.5 216,154.5 229.8,192.4 233.1,245.7 234.2,262.5 234.3,303.9  259.8,303.9 260,262.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1618.7,153.7 1542.5,210.3 1556.6,176.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1442.8,153.7 1518.4,210.9 1505,176.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1591.3,284.9 1571,316 1614.4,327.9 1626.9,285.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1434.8,285.6 1447.2,327.9 1490.6,316 1470.3,284.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1488.1,232.4 1476,250.7 1519.2,252.6 1517.6,206.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1573.4,232.4 1543.5,205.7 1542.5,252.6 1585.5,250.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1490.6,316 1516.5,303.4 1494.1,285.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1545,303.4 1571,316 1567.4,285.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1571,316 1545,303.4 1547.1,320.3 1546.9,327.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1490.6,316 1514.7,327.4 1514.6,320.3 1516.5,303.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1515.1,274.7 1493.5,268.4 1508.7,261.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.4,274.7 1552.8,261.4 1568.1,268.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1490.6,316 1494.3,284.9 1470.3,285.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1567.3,284.9 1571,316 1591.3,285.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1585.5,250.7 1542.5,252.6 1546.5,274.7 1552.8,261.4 1568.2,268.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1493.5,268.4 1508.8,261.4 1515.1,274.7 1519.2,252.6 1476,250.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1476,250.7 1494.1,285.9 1493.5,268.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1568.2,268.4 1567.4,285.9 1585.5,250.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1519.2,252.6 1515.1,274.7 1520.1,300.8 1521.3,266.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "1542.5,252.6 1540.4,266.4 1541.4,300.8 1546.5,274.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1546.5,274.7 1541.4,300.8 1545,303.4 1567.4,285.9 1568.2,268.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1493.5,268.4 1494.1,285.9 1516.5,303.4 1520.1,300.8 1515.1,274.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "1546.9,327.4 1547.1,320.3 1545.2,318.6 1516.3,318.6 1514.6,320.3 1514.7,327.4 1490.6,316  1499,322.9 1516.1,334.8 1545.4,334.8 1562.6,322.9 1571,316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1545,303.4 1541.4,300.8 1520.1,300.8 1516.5,303.4 1514.6,320.3 1516.3,318.6 1545.2,318.6  1547.1,320.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1621.9,214 1628.4,182.8 1618.7,153.7 1545,208.4 1573.4,232.4 1613.4,244.1 1622.3,233.8  1618.5,231 1624.6,225.4 1619.8,221.7 1626,217.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1433.2,182.8 1439.7,214 1435.5,217.1 1441.7,221.7 1437,225.4 1443.1,231 1439.3,233.8  1448.1,244.1 1488.1,232.4 1516.5,208.4 1442.8,153.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1613.4,244.1 1573.4,232.4 1585.5,250.7 1567.4,285.9 1591.3,285.6 1626.9,285.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1488.1,232.4 1448.1,244.1 1434.8,285.6 1470.3,285.6 1494.1,285.9 1476,250.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1542.5,252.6 1545,208.4 1556.7,176.9 1505,176.9 1516.5,208.4 1519.2,252.6 1520.1,266.5  1520.1,300.8 1541.4,300.8 1541.5,266.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskBrowserIcon);
export default __webpack_public_path__ + "static/media/metamask_browser_icon.4f0193544b887a9ed4247b05b632f906.svg";
export { ForwardRef as ReactComponent };